import { render, staticRenderFns } from "./lgScreenSetJg.vue?vue&type=template&id=a3f45638"
import script from "./lgScreenSetJg.vue?vue&type=script&lang=js"
export * from "./lgScreenSetJg.vue?vue&type=script&lang=js"
import style0 from "./lgScreenSetJg.vue?vue&type=style&index=0&id=a3f45638&prod&lang=less"
import style1 from "./lgScreenSetJg.vue?vue&type=style&index=1&id=a3f45638&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports